import React, { useCallback, useEffect, useState } from "react";
import { Alert, Button } from "antd";
import { useHistory, useRouteMatch } from "react-router-dom";
import { Tables } from "components/layout";
import { Localize } from "components/service";
import { GET_STAFF_MANAGEMENT_CHECK_IN_HISTORY } from "graphql/query/staff-management-gql";
import StaffManagementConst from "components/staff-management/staff-management-const";
import useStaffCheckInHistory from "components/staff-management/hooks/use-staff-check-in-history";
import StaffCheckInHistoryTableHelper from "components/staff-management/helpers/staff-check-in-history-table-helper";
import StaffCheckInHistoryTableFilter from "components/staff-management/filters/staff-check-in-history-table-filter";
import StaffCheckInHistoryDetailsModal from "components/staff-management/fields/staff-check-in-history-details-modal";
import { STAFF_CHECK_IN_HISTORY_PAGE_SIZE } from "components/staff-management/helpers/staff-check-in-history-api-helper";


const StaffManagementCheckInHistorySubPage = ({ event }) => {
    const history = useHistory();
    const routeUrl = `${ StaffManagementConst.basePath }/${ event.id }/check-in-history`;
    const match = useRouteMatch(`${ routeUrl }/page/:pageNum`);
    const parsedPage = match ? Number(match.params.pageNum) : 1;
    const validPage = Number.isInteger(parsedPage) && parsedPage > 0;
    const requestedPage = validPage ? parsedPage : 1;
    const canonicalPagePath = !match || (validPage && parsedPage > 1);
    const [ period, setPeriod ] = useState([]);
    const [ log, setLog ] = useState();
    const { tableModel, loading, error, retry, variables } = useStaffCheckInHistory({
        eeID: event.id,
        period,
        page: requestedPage,
    });

    const changePeriod = useCallback((value) => {
        setPeriod(value || []);
        setLog(undefined);
        if (requestedPage !== 1)
        {
            history.push(routeUrl);
        }
    }, [ history, requestedPage, routeUrl ]);

    useEffect(() => {
        if (!canonicalPagePath)
        {
            history.replace(routeUrl);
        }
    }, [ canonicalPagePath, history, routeUrl ]);

    return (
        <div className="staff-management-view-shell--check-in-history">
            <p className="staff-check-in-history__description">
                <Localize>STAFF_MANAGEMENT.History_Description</Localize>
            </p>
            <Tables.Main
                querySkip
                model="exhibitionEventCheckinLogs"
                query={ GET_STAFF_MANAGEMENT_CHECK_IN_HISTORY }
                externalModel={ tableModel }
                externalLoading={ loading }
                tableVisible={ !error }
                routeUrl={ routeUrl }
                currentPage={ requestedPage }
                currentObj={ { onDetails: setLog } }
                objFilter={ variables.where }
                objOrderBy={ variables.orderBy }
                varSet={ { perPage: STAFF_CHECK_IN_HISTORY_PAGE_SIZE } }
                tableHelper={ StaffCheckInHistoryTableHelper }
                extraClass="staff-check-in-history-table"
                scroll={ { x: 1100 } }>
                <StaffCheckInHistoryTableFilter period={ period } onChange={ changePeriod } />
                { error &&
                    <Alert
                        className="staff-check-in-history__error"
                        type="error"
                        showIcon
                        message={ <Localize>STAFF_MANAGEMENT.History_LoadError</Localize> }
                        action={
                            <Button onClick={ retry } loading={ loading } disabled={ loading }>
                                <Localize>STAFF_MANAGEMENT.History_Retry</Localize>
                            </Button>
                        } />
                }
            </Tables.Main>
            <StaffCheckInHistoryDetailsModal log={ log } onClose={ () => setLog(undefined) } />
        </div>
    );
};

export default StaffManagementCheckInHistorySubPage;
